import { resolveSiteUrl } from '../lib/resolveSiteUrl';

/** Canonical origin — override with `REACT_APP_SITE_URL` (e.g. https://www.streetsaudio.com). */
export const SITE_URL = resolveSiteUrl();
export const SITE_NAME = 'Streets Audio';

/** Branded default for Open Graph / Twitter when a page has no custom image (1200×630). */
export const DEFAULT_OG_IMAGE_PATH = '/og-default.png';

export function getDefaultOgImageUrl(): string {
  return `${SITE_URL}${DEFAULT_OG_IMAGE_PATH}`;
}

export function getCanonicalUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${cleanPath}`;
}

export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
};

